export const formatToCstTime = (localDate = new Date()) => {
	const timeZone = 'America/Chicago';
	const hours = localDate.toLocaleTimeString('en-US', {
		hour12: false,
		hour: '2-digit',
		timeZone,
	});
	const minutes = localDate.toLocaleTimeString('en-US', {
		minute: '2-digit',
		timeZone,
	});
	localDate.setHours(Number(hours));
	localDate.setMinutes(Number(minutes));
	return localDate;
};


export const withinCallCenterHours = (localDate = new Date()) => {
	const cstTime = formatToCstTime(localDate);
	const day = cstTime.getDay();
	const hours = cstTime.getHours();
	const minutes = cstTime.getMinutes();
	// the call center is opened for the same hours during the week
	// and slightly different hours on the weekend
	switch (day) {
		case 0: // Sunday
			return hours >= 8 && hours < 19;
		case 6: // Saturday
			return hours >= 7 && hours < 20;
		default: // Mon-Fri
			// eslint-disable-next-line no-mixed-operators
			return (hours > 6 || (hours === 6 && minutes >= 30)) && hours < 23;
	}
};
